"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _appActions = require("../actions/appActions");
var _wsConnectionActions = require("../actions/wsConnectionActions");
var _lifeCycleActions = require("../actions/lifeCycleActions");
var _delay = _interopRequireDefault(require("lodash/delay"));
var _redux = require("redux");
var _apex = require("../../apex");
var _snackbarActions = require("../actions/snackbarActions");
var _authActions = require("../actions/authActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// delays[0] will never be used,
// but it gets the rest of the value's indexes to align with wsCloseCount
var delays = [0, 10000, 10000, 10000, 30000, 30000, 30000, 60000, 60000, 60000, 120000];
var _default = exports["default"] = function _default(store) {
  return function (next) {
    return function (action) {
      switch (action.type) {
        case _wsConnectionActions.CONNECTION_OPENED:
          // Mark if this reconnection happened during 2FA flow
          (0, _authActions.mark2FAReconnection)();
          store.dispatch((0, _wsConnectionActions.connectionClosedCount)(0));
          store.dispatch((0, _appActions.loadStartupData)());
          store.dispatch((0, _lifeCycleActions.onInit)());
          break;
        case _wsConnectionActions.CONNECTION_CLOSED:
          {
            var wsCloseCount = store.getState().wsConnection.tries + 1;
            var delayTimer = wsCloseCount >= delays.length ? delays[delays.length - 1] : delays[wsCloseCount];
            store.dispatch((0, _wsConnectionActions.connectionClosedCount)(wsCloseCount));
            store.dispatch(connectionWarningSnackbar(wsCloseCount, delayTimer));
            var open = (0, _redux.bindActionCreators)(_wsConnectionActions.connectionOpened, store.dispatch);
            var close = (0, _redux.bindActionCreators)(_wsConnectionActions.connectionClosed, store.dispatch);
            (0, _delay["default"])(_apex.initApex, delayTimer, open, close);
            break;
          }
        default:
          break;
      }
      return next(action);
    };
  };
};
var connectionWarningSnackbar = function connectionWarningSnackbar(attemptCount, delayTimer) {
  // t('Connection with server lost. Attempting reconnect...')
  var snackText = 'Connection with server lost. Attempting reconnect...';
  if (attemptCount > 1) {
    // t('Still unable to connect after {{attemptCount}} attempts, trying again...')
    snackText = 'Still unable to connect after {{attemptCount}} attempts, trying again...';
  }
  return (0, _snackbarActions.showSnack)({
    id: 'websocketConnectionLost',
    text: snackText,
    textVars: {
      attemptCount: attemptCount
    },
    type: 'warning',
    timeout: delayTimer
  });
};